import { usePropertiesGroups } from './properties-groups';
import { PropertyMarker } from '../components/map-search/property-marker';

export function useMarkers({
  map,
  properties,
  zoom,
  fitBounds,
  highlightProperties,
}) {
  let groups = usePropertiesGroups(properties, zoom);

  if (!groups) return [];

  return groups.map(x => (
    <PropertyMarker
      key={`${x.coords[0]}/${x.coords[1]}/${zoom}`}
      {...x}
      map={map}
      fitBounds={fitBounds}
      highlight={highlightProperties}
    />
  ));
}
